import { createSlice } from "@reduxjs/toolkit";
import { SettingsState } from "./settingsStateModels";

const initialState: SettingsState = {
  showMenus: true,
  openPanel: null,
};

const settingsSlice = createSlice({
  name: "settingsSlice",
  initialState,
  reducers: {
    /**
     * Set whether to show the main menus or not
     * This is in Redux because other parts of the UI may change this value
     */
    setShowMenus(state, action: { payload: SettingsState["showMenus"] }) {
      state.showMenus = action.payload;
    },
    /**
     * Set which panel is open (if any)
     * This is in Redux because other parts of the UI may change this value
     */
    setOpenPanel(state, action: { payload: SettingsState["openPanel"] }) {
      state.openPanel = action.payload;
    },
  },
});

export const { setShowMenus, setOpenPanel } = settingsSlice.actions;

export default settingsSlice.reducer;
